"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var I18NextProvider_1 = require("./I18NextProvider");

var NamespaceProvider_1 = require("./NamespaceProvider");

exports.default = function (defaultNs) {
  return function (Component) {
    var WithLocale = function WithLocale(props) {
      return React.createElement(I18NextProvider_1.I18NextConsumer, null, function (_a) {
        var i18n = _a.i18n,
            locale = _a.locale;
        return React.createElement(NamespaceProvider_1.NameSpaceConsumer, null, function (ns) {
          return React.createElement(Component, __assign({
            t: i18n.t,
            i18n: i18n,
            locale: locale,
            tn: function tn(key, interpolate) {
              return i18n.t((defaultNs || ns) + ":" + key, interpolate);
            }
          }, props));
        });
      });
    };

    return WithLocale;
  };
};